import OnlineIcon from '@/../public/explore/onlineIcon.png';
import { ExperienceMode } from '@/generated/graphql';
import styled from '@emotion/styled';
import { Avatar, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useLocationFilterModalAtom } from '../hooks/use-location-filter-modal';
import useSetMode from '../hooks/use-set-mode';
import BigFilterButton from './big-filter-button';
const StyledAvatar = styled(Avatar)`
  border-radius: 0;
  & > img {
    object-fit: contain;
  }
  max-width: fit-content;
`;
const OnineModeFilterButton = ({ active }: { active: boolean }) => {
  const setMode = useSetMode();
  const { setLocationFilterModal } = useLocationFilterModalAtom();
  const router = useRouter();

  const onClick = () => {
    setMode(ExperienceMode.Online);
    const newUrl = `/explore/?mode=${ExperienceMode.Online}`;
    router.push(newUrl);
    setLocationFilterModal(false);
  };
  const startIcon = (
    <StyledAvatar
      src={OnlineIcon.src}
      style={{ borderRadius: 0, objectFit: 'contain' }}
    ></StyledAvatar>
  );
  const buttonImg = <Image src={OnlineIcon.src} alt={''} width={24} height={24} />;
  const isMobile = useMediaQuery('(max-width: 960px');
  return (
    <BigFilterButton
      className={active ? 'active' : ''}
      startIcon={isMobile ? null : startIcon}
      onClick={onClick}
    >
      <div>{isMobile ? buttonImg : null}&nbsp;</div>
      <div>{'Online'}</div>
    </BigFilterButton>
  );
};

export default OnineModeFilterButton;
